<template>
    <ScrollableView class="bg-green">

        <div class="mx-auto py-8 max-w-sm text-center text-90">
            <img src="/logo.svg" style="height: 40px;" class="inline" />
        </div>

        <form
            class="bg-white shadow rounded-lg p-8"
            @submit.prevent="handleSubmit">


                <h2 class="text-2xl text-center font-normal mb-6 text-90">{{ $t("Welcome Back!") }}</h2>
                <svg class="block mx-auto mb-6" xmlns="http://www.w3.org/2000/svg" width="100" height="2" viewBox="0 0 100 2"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="08-login" fill="#D8E3EC" transform="translate(-650 -371)"><path id="Rectangle-15" d="M650 371h100v2H650z"/></g></g></svg>

            <div class="mb-6">
                <label class="block font-semibold mb-2" for="email">{{ $t('Email Address') }}</label>

                <input
                    v-model="email"
                    type="text"
                    name="email"
                    class="form-control form-input form-input-bordered w-full"
                    />

                <div v-show="submitted && !email" class="text-red mt-3">
                    {{ $t("Email is required") }}
                </div>
            </div>

            <div class="mb-6">
                <label class="block font-semibold mb-2" for="password">{{ $t('Password') }}</label>

                <input
                    v-model="password"
                    type="password"
                    name="password"
                    class="form-control form-input form-input-bordered w-full"
                    />

                <div v-show="submitted && !password" class="text-red mt-3">
                    {{ $t("Password is required") }}
                </div>
            </div>

            <button
                class="w-full btn btn-default btn-primary bg-red"
                type="submit"
                :disabled="loggingIn">
                    <span v-if="!loggingIn">{{ $t('Login') }}</span>
                    <loader v-else />
            </button>

            <div class="mt-3">
                <router-link class="underline" :to="{name: 'password-reset-link-request'}">
                    {{ $t("Forgot your password?") }}
                </router-link>
            </div>

        </form>

        <p class="mt-6 text-center text-80">Version: {{ version }} <a class="underline" @click="update">{{ $t("check for updates") }}</a></p>
    </ScrollableView>
</template>

<script>
import { version } from '@mobile/../package.json';
import Loader from '@mobile/components/Loader.vue';
import ScrollableView from '@mobile/components/ScrollableView.vue';

export default {
    components: { Loader, ScrollableView },
    data() {
        return {
            email: '',
            password: '',
            submitted: false,
        };
    },
    computed: {
        loggingIn() {
            return this.$store.state.authentication.loggingIn;
        },
        version() {
            return version;
        },
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;
            if (this.email && this.password) {
                this.$store.dispatch('authentication/login', {
                    email: this.email,
                    password: this.password,
                    nextUrl: this.$route.query.nextUrl,
                });
            }
        },

        update() {
            if (window.serviceWorkerRegistration) {
                console.log('trying to update service worker');
                window.serviceWorkerRegistration
                    .update()
                    .catch(() => {});
            }
        },
    },
};
</script>
